import { Typography } from "@voicely/ui-mui/data-display/Typography";
import { Alert } from "@voicely/ui-mui/feedback/Alert";
import { Button } from "@voicely/ui-mui/form/Button";
import { Box } from "@voicely/ui-mui/layout/Box";
import { Stack } from "@voicely/ui-mui/layout/Stack";
import { useRouteError } from "react-router";

export const ErrorFallback = () => {
	const error = useRouteError();
	const message = error instanceof Error ? error.message : String(error);

	return (
		<Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
			<Stack spacing={2} sx={{ maxWidth: 560, width: "100%" }}>
				<Typography variant="h4">Something broke</Typography>
				<Alert severity="error" sx={{ wordBreak: "break-word" }}>
					{message}
				</Alert>
				<Box>
					<Button variant="outlined" onClick={() => window.location.reload()}>
						Reload
					</Button>
				</Box>
			</Stack>
		</Box>
	);
};
